import {
  BarChart3,
  Braces,
  Columns3,
  Database,
  Eye,
  FunctionSquare,
  Hash,
  KeyRound,
  LayoutGrid,
  ListTree,
  Lock,
  Sigma,
  Table2,
  Zap,
} from 'lucide-react';

import type { DbTreeIcon } from '@/lib/db-browser/tree';
import { cn } from '@/lib/utils';

const ICONS: Record<DbTreeIcon, { Icon: typeof Table2; color: string }> = {
  database: { Icon: Database, color: 'text-accent-600' },
  schema: { Icon: LayoutGrid, color: 'text-accent-600' },
  table: { Icon: Table2, color: 'text-accent-600' },
  view: { Icon: Eye, color: 'text-violet-600 dark:text-violet-400' },
  matview: { Icon: ListTree, color: 'text-violet-600 dark:text-violet-400' },
  function: { Icon: FunctionSquare, color: 'text-amber-700 dark:text-amber-400' },
  procedure: { Icon: Sigma, color: 'text-amber-700 dark:text-amber-400' },
  trigger_function: { Icon: Zap, color: 'text-amber-600 dark:text-amber-400' },
  sequence: { Icon: Hash, color: 'text-teal-700 dark:text-teal-400' },
  type: { Icon: Braces, color: 'text-text-secondary' },
  column: { Icon: Columns3, color: 'text-text-secondary' },
  column_pk: { Icon: KeyRound, color: 'text-amber-700 dark:text-amber-400' },
  column_sensitive: { Icon: Lock, color: 'text-amber-800 dark:text-amber-300' },
  constraint: { Icon: KeyRound, color: 'text-text-secondary' },
  index: { Icon: BarChart3, color: 'text-teal-700 dark:text-teal-400' },
  trigger: { Icon: Zap, color: 'text-amber-600 dark:text-amber-400' },
};

export function DbObjectIcon({ icon, className }: { icon: DbTreeIcon; className?: string }) {
  const { Icon, color } = ICONS[icon];
  return <Icon size={15} aria-hidden="true" className={cn('shrink-0', color, className)} />;
}
